import React, { Component } from 'react';
import './index.scss';

function conditionParser(condition, props) {
  const type = condition.type
  switch (type) {
    case 'props':
      return condition.propsKeys.every(key => !!props[key])
    case 'func':
      const funcParsed = new Function('props', condition.funBody);
      return funcParsed.call(null, props);
    case 'async':
      const asyncFuncParsed = new Function('props', condition.asyncFunBody);
      return fetch(`${condition.url}?detailId=${1111}`)
        .then(res => res.json)
        .then((data) => {
          return asyncFuncParsed.call(null, data);
        })
    default:
      return false;
  }
}

class Tag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    }
  }
  componentDidMount() {
    const {
      tag,
      data
    } = this.props
    if (tag.condition.type === 'async') {
      conditionParser(tag.condition, data)
        .then((data) => {
          this.setState({
            // data中要根据业务要求计算出show的值，show-true展示标签，false不展示标签
            ...data,
          })
        })
        .catch((err) => console.log(err))
    } else {
      this.setState({
        show: conditionParser(tag.condition, data),
        ...tag
      })
    }
  }
  handleClick = (actionConfig = {}) => () => {
    if (actionConfig.type === 'click') {
      console.log('fire action: ', actionConfig.key)
    }
  }
  render() {
    const {
      props
    } = this;
    const { tag } = props;
    const { show } = this.state;
    return show ? <div className="pdp-tag" onClick={this.handleClick(tag.action)}>{tag.i18nKey}</div> : null;
  }
}

export default class TitleAccessory extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      props,
    } = this;
    const {
      product,
      productIsPersonal,
      tags = [
        {
          tagName: 'personalProdTag',
          i18nKey: 'marketAction_title_tag_personal',
          condition: {
            type: 'func',
            funBody: 'return !!props.productIsPersonal'
          },
          action: {
            key: 'onPersonalKeyClick',
            type: 'click',
          },
          icon: 'xxx-icon'
        },
        {
          tagName: 'showYdtTag',
          i18nKey: 'Custom Data',
          condition: {
            type: 'props',
            propsKeys: ['showYdtTag']
          },
          action: {
            key: 'onCustomTagClick',
            type: 'click',
          }
        },
        // {
        //   tagName: 'transactionHistoryTag',
        //   i18nKey: 'Hot sale in',
        //   condition: {
        //     type: 'async',
        //     asyncFunBody: '',
        //   },
        // }
      ]
    } = props

    return [
      <span className="promotion-tags" id="detail-title-tags-below-title"></span>,
      <div className="pdp-tag-wrap">
        {
          tags.map((tag) => <Tag tag={tag} data={this.props} key={tag.tagName} />)
        }
      </div>
    ];
  }
}
